import { Component, OnDestroy, OnInit } from "@angular/core";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import Swal from "sweetalert2";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

declare var bootstrap: any;

const MESES = ["", "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

@Component({
  selector: "app-siaps-importacao",
  templateUrl: "./siaps-importacao.component.html",
  styleUrls: ["./siaps-importacao.component.css"],
})
export class SiapsImportacaoComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  uploading: boolean = false;
  usuario: any;

  progressoTotal: number = 0;
  progressoProcessado: number = 0;
  private pollingHandle: any = null;

  listaImportacoes: any[] = [];

  tiposIndicador = [
    { value: 1, label: "Diabetes" },
    { value: 2, label: "Hipertensão" },
  ];

  formulario: any = {
    tipo_indicador: 1,
  };
  arquivoSelecionado: File = null;
  arquivoNomeUpload: string = null;

  itemDetalhe: any = null;
  registrosDetalhe: any[] = [];
  somentePendentes: boolean = false;

  constructor(public global: Global, public service: ApiService, private authService: AuthService) {
    this.authService.currentUser.subscribe((res) => {
      if (res) this.usuario = res;
    });
  }

  ngOnInit() {
    this.listar();
  }

  ngOnDestroy() {
    if (this.pollingHandle) clearTimeout(this.pollingHandle);
  }

  listar() {
    this.loading = true;
    this.service
      .Get("SiapsImportacao")
      .then((res: any) => {
        this.listaImportacoes = res;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
        Swal.fire({ title: "Erro!", text: "Ocorreu um erro ao buscar as importações.", icon: "error" });
      });
  }

  onFileSelected(event) {
    this.arquivoSelecionado = event.target.files.length ? event.target.files[0] : null;
  }

  importar() {
    if (!this.arquivoSelecionado) {
      Swal.fire({ title: "Atenção", text: "Selecione o arquivo (.xlsx) para importar.", icon: "warning" });
      return;
    }

    this.uploading = true;
    this.arquivoNomeUpload = this.arquivoSelecionado.name;
    this.progressoTotal = 0;
    this.progressoProcessado = 0;

    const formData = new FormData();
    formData.append("arquivo", this.arquivoSelecionado, this.arquivoSelecionado.name);
    formData.append("tipo_indicador", this.formulario.tipo_indicador);
    if (this.usuario && this.usuario.usuario_id) formData.append("usuario_id", this.usuario.usuario_id);

    this.service
      .PostFormData("SiapsImportacao/upload", formData)
      .then((res: any) => {
        this.arquivoSelecionado = null;
        const input: any = document.getElementById("inputArquivoSiaps");
        if (input) input.value = "";

        this.acompanharProgresso(res.job_id);
      })
      .catch((err) => {
        this.uploading = false;
        this.exibirErroImportacao(err);
      });
  }

  private acompanharProgresso(jobId: string) {
    this.service
      .Get(`SiapsImportacao/upload/status/${jobId}`)
      .then((res: any) => {
        this.progressoTotal = res.total;
        this.progressoProcessado = res.processado;

        if (!res.concluido) {
          this.pollingHandle = setTimeout(() => this.acompanharProgresso(jobId), 600);
          return;
        }

        this.uploading = false;

        if (res.erro) {
          Swal.fire({ title: "Erro!", text: res.erro, icon: "error" });
          return;
        }

        const resultado = res.resultado;
        Swal.fire({
          title: "Importação concluída!",
          html: `Competência <b>${MESES[resultado.competencia_mes]}/${resultado.competencia_ano}</b>, equipe <b>${resultado.equipe_ine}</b>: <b>${resultado.quantidade_registros}</b> registros importados.`,
          icon: "success",
        });
        this.listar();
      })
      .catch((err) => {
        this.uploading = false;
        this.exibirErroImportacao(err);
      });
  }

  private exibirErroImportacao(err: any) {
    let mensagem = "Ocorreu um erro ao importar o arquivo.";
    if (err && err.error) {
      if (err.error.erros && err.error.erros.length) mensagem = err.error.erros[0].messagem;
      else if (err.error.messagem) mensagem = err.error.messagem;
    }
    Swal.fire({ title: "Erro!", text: mensagem, icon: "error" });
  }

  get progressoPercentual(): number {
    if (!this.progressoTotal) return 0;
    return Math.round((this.progressoProcessado / this.progressoTotal) * 100);
  }

  visualizar(item: any) {
    this.loading = true;
    this.somentePendentes = false;

    this.service
      .Get(`SiapsImportacao/${item.id}`)
      .then((res: any) => {
        this.loading = false;
        this.itemDetalhe = res.importacao;
        this.registrosDetalhe = res.registros;

        const modalElement = document.getElementById("modalDetalheSiaps");
        if (modalElement) new bootstrap.Modal(modalElement).show();
      })
      .catch(() => {
        this.loading = false;
        Swal.fire({ title: "Erro!", text: "Ocorreu um erro ao buscar os registros importados.", icon: "error" });
      });
  }

  remover(item: any) {
    Swal.fire({
      title: "Atenção",
      text: `Deseja realmente remover a importação de ${item.tipo_indicador === "DIABETES" ? "Diabetes" : "Hipertensão"} (${MESES[item.competencia_mes]}/${item.competencia_ano})? Os dados importados serão removidos da listagem.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, remover",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#dc3545",
    }).then((result) => {
      if (!result.isConfirmed) return;

      this.loading = true;
      this.service
        .Delete(`SiapsImportacao/${item.id}`)
        .then(() => {
          this.loading = false;
          Swal.fire({ title: "Sucesso!", text: "Importação removida com sucesso.", icon: "success" });
          this.listar();
        })
        .catch(() => {
          this.loading = false;
          Swal.fire({ title: "Erro!", text: "Ocorreu um erro ao remover a importação.", icon: "error" });
        });
    });
  }

  registroPendente(registro: any): boolean {
    if (this.itemDetalhe && this.itemDetalhe.tipo_indicador === "DIABETES")
      return !(registro.indicador_a_consulta && registro.indicador_b_pressao_arterial && registro.indicador_c_antropometria
        && registro.indicador_d_visita_domiciliar && registro.indicador_e_hemoglobina_glicada && registro.indicador_f_avaliacao_pes);

    return !(registro.indicador_a_consulta && registro.indicador_b_pressao_arterial && registro.indicador_c_antropometria
      && registro.indicador_d_visita_domiciliar);
  }

  get registrosFiltrados(): any[] {
    if (!this.somentePendentes) return this.registrosDetalhe;
    return this.registrosDetalhe.filter((r) => this.registroPendente(r));
  }

  competencia(item: any): string {
    return `${MESES[item.competencia_mes]}/${item.competencia_ano}`;
  }
}
